import React from 'react';
import GeneralList from './GeneralList';
import { teacherConfig } from './Config';

export default function TeacherList() {
  return (
    <GeneralList
      title={teacherConfig.title}
      addLabel={teacherConfig.addLabel}
      icon={teacherConfig.icon}
      fetchUrl={teacherConfig.fetchUrl}
      submitUrl={teacherConfig.submitUrl}
      createDataFunction={teacherConfig.createDataFunction}
      rowHeaders={teacherConfig.rowHeaders}
      editFields={teacherConfig.fields}
      displayFields={teacherConfig.displayFields}
      detailFields={teacherConfig.detailFields}
    />
  );
}

